import { HARDCODED_VALUES } from './hardcoded-values';

export interface MenuItem {
    label: string;
    link: string;
    icon?: string;
}

export const secondaryMenu: MenuItem[] = [
    {
        label: "Discord",
        link: HARDCODED_VALUES.discord.inviteLink,
        icon: "discord fab",
    },
    {
        label: "Terms of Service",
        link: "internal:tos",
        icon: "file-contract",
    },
];